import { useFeatureValue } from '@growthbook/growthbook-react';
import type { PropsWithChildren } from 'react';
import { MaintenancePage } from './maintenancePage';

export function MaintenanceModeWrapper({ children }: PropsWithChildren) {
  const isMaintenanceMode = useFeatureValue('maintenance-mode', false);

  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }

  return children;
}
